{
    "NAME": "DirectoryModal",
    "AddDirectoryTitle": "Ajouter un répertoire",
    "ModifyDirectoryTitle": "Modifier le répertoire",
    "TelServerFormLabel": "Serveur téléphonique",
    "PartitionFormLabel": "Partition",
    "TelNumberFormLabel": "Numéro de téléphone",
    "DescriptionFormLabel": "Description",
    "DirectoryAddModify_UnknownOrDeleted": "[Inconnu ou supprimé]",
    "DirectoryAddModify_ServerErrorTitle": "Erreurs de validation",
    "DirectoryAddModify_ValidationWarning": "Veillez à ce que tous les champs soient correctement remplis",
    "DirectoryAddModify_ButtonHelpLabel": "Aide ?",
    "DirectoryAddModify_ButtonSubmitLabel": "Économiser",
    "DirectoryAddModify_ButtonCancelLabel": "Annuler",
    "DirectoryAddModify_PromptMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues à la fermeture.",
    "DirectoryAddModify_PromptConfirm": "Oui",
    "DirectoryAddModify_PromptCancel": "Annuler",
    "TelNumberFormLabel_Validation_Error": "Le numéro de téléphone est requis",
    "DescriptionFormLabel_Validation_Error": "La description est obligatoire",
    "DirectoryAddModify_TabsDetails": "Détails"
}